import { render } from "./ForecastControls.vue?vue&type=template&id=e534b5ba&scoped=true"
import script from "./ForecastControls.vue?vue&type=script&lang=js"
export * from "./ForecastControls.vue?vue&type=script&lang=js"

import "./ForecastControls.vue?vue&type=style&index=0&id=e534b5ba&scoped=true&lang=css"

import exportComponent from "/Users/antoniomarrazzo/Janus - Pasar/janus-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e534b5ba"]])

export default __exports__